 
import Slider from "react-slick";  
const Cocurricular = () => {
    var settings = {
        autoplay: true,
        infinite: true, 
        autoplaySpeed: 2000,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow:3,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      };
  return (
     <> 
     
     <Slider {...settings}>
       <div className="item"> 
          <img src="https://webapi.entab.info/api/image/CSFL/public/images/acti1.png" className="img-fluid" /> 
        </div> 
        <div className="item">  
          <img src="https://webapi.entab.info/api/image/CSFL/public/images/acti2.png" className="img-fluid" /> 
        </div>
        <div className="item">   
        <img src="https://webapi.entab.info/api/image/CSFL/public/images/achv4.jpg" className="img-fluid" />
      </div>
      <div className="item">   
        <img src="https://webapi.entab.info/api/image/CSFL/public/images/achv5.jpg" className="img-fluid" />
      </div>
      <div className="item">   
        <img src="https://webapi.entab.info/api/image/CSFL/public/images/achv6.jpg" className="img-fluid" />
      </div>
        <div className="item">   
        <img src="https://webapi.entab.info/api/image/CSFL/public/images/achv7.jpg" className="img-fluid" />
      </div>
      <div className="item">  
          <img src="https://webapi.entab.info/api/image/CSFL/public/images/acti3.png" className="img-fluid" /> 
        </div>
     </Slider>
      
     </>
  )
}

export default Cocurricular
